import { h as hasNamedSlot, k as getNamedSlotTextContent, b as bem } from './p-g1JgJ7wn.js';
import { h } from './p-BJEvNVLM.js';

const FormField = ({ helpText, appearance = 'dark', disabled, label, invalid, labelForValue, requiredLabel, optionalLabel, validationMessage, class: classname, element, required, validationMessageRef, }, children) => {
    const generateClassNames = bem('cosmos-form-field');
    const requiredOrOptionalLabel = required ? requiredLabel : optionalLabel;
    const helperText = getHelpText();
    const handleLabelClick = () => {
        const target = element.shadowRoot.querySelector(`#${labelForValue}`);
        if (target === null || target === void 0 ? void 0 : target.hasAttribute('role')) {
            target.focus();
        }
    };
    function getHelpText() {
        if (helpText) {
            return helpText;
        }
        if (hasNamedSlot(element, 'help-text')) {
            return getNamedSlotTextContent(element, 'help-text');
        }
        return ''; // Return empty string to avoid aria-label being omitted
    }
    return (h("div", { class: [
            classname,
            generateClassNames({
                invalid,
                disabled,
                appearance,
            }),
        ].join(' '), part: "base" },
        h("div", { class: generateClassNames('info-container', {
                'has-label': !!label,
                'has-help-text': !!helperText,
                'has-required-optional-label': !!requiredOrOptionalLabel,
            }) },
            h("label", { htmlFor: labelForValue !== null && labelForValue !== void 0 ? labelForValue : undefined, class: generateClassNames('label'), onClick: handleLabelClick },
                h("cosmos-text", { appearance: appearance, class: generateClassNames('label-text'), exportparts: "base: label", size: "x-small", tag: "span", weight: "medium" },
                    h("span", { id: "label" }, label)),
                requiredOrOptionalLabel && (h("cosmos-text", { appearance: appearance, "aria-hidden": "true", class: generateClassNames('required-optional-label'), exportparts: "base: required-label", kind: "subtle", size: "xx-small", tag: "span" }, requiredOrOptionalLabel))),
            h("cosmos-text", { appearance: appearance, class: generateClassNames('help-text'), kind: "subtle", size: "x-small", exportparts: "base: help-text" },
                h("span", { "aria-label": helperText, id: "help-text" },
                    h("slot", { name: "help-text" }, helpText)))),
        h("div", null, children),
        h("div", { "aria-atomic": "false" // Announce only the changed node. NVDA would re-announce the message twice when set to true
            , "aria-live": "polite" // Announce the validation message in a non-interruptive way
            , class: generateClassNames('validation-message-container') }, invalid && validationMessage && (h("div", { class: generateClassNames('validation-message') },
            h("cosmos-icon-warning", { "aria-hidden": "true", class: generateClassNames('validation-message-icon') }),
            h("cosmos-text", { appearance: appearance, class: generateClassNames('validation-message-text'), exportparts: "base: validation-message", size: "x-small", tag: "span" },
                h("span", { "aria-label": validationMessage, id: "validation-message", ref: validationMessageRef }, validationMessage)))))));
};

export { FormField as F };
